module.exports = __webpack_public_path__ + "static/media/aehsHero.b4038a14.png";